import { useApi } from '@/api'

export const useBrandKitsResource = () => {
  const api = useApi()
  const brandOf = (organizationId: string, brandId: string) => api.api.v1.organizations({ organizationId }).brands({ brandId })

  return {
    getBrandKit: (organizationId: string, brandId: string) => brandOf(organizationId, brandId).kit.get(),
    setBrandKit: (organizationId: string, brandId: string, body: Parameters<ReturnType<typeof brandOf>['kit']['patch']>[0]) =>
      brandOf(organizationId, brandId).kit.patch(body)
  }
}
